import { useState } from "react";
import ToolkitAppScroller from "components/BeyondToolkit/ToolkitAppScroller";
import CountdownCard from "components/Timer/CountdownCard";
import CustomTimeModal from "components/Timer/CustomTimeModal";
import TimerOptions from "components/Timer/TimerOptions";
import { TIMER } from "utils/beyondToolkitTools";

function Timer() {
  const [display, setDisplay] = useState("default");
  const [seconds, setSeconds] = useState<number | null>(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const { title, imgSrc } = TIMER();

  const openTimer = (input: number) => {
    setDisplay("timer");
    setSeconds(input);
    setShowCustomModal(false);
  };

  const closeTimer = () => {
    setDisplay("default");
    setSeconds(null);
  };

  const openCustomModal = () => {
    setShowCustomModal(true);
  };

  const closeCustomModal = () => {
    setShowCustomModal(false);
  };

  return (
    <ToolkitAppScroller title={title} variant="timer" imgSrc={imgSrc}>
      {display === "timer" && <CountdownCard goBack={closeTimer} seconds={seconds ?? 0} />}
      {display === "default" && <TimerOptions openTimer={openTimer} openCustomModal={openCustomModal} />}
      {showCustomModal && <CustomTimeModal startTimer={openTimer} goBack={closeCustomModal} />}
    </ToolkitAppScroller>
  );
}

export default Timer;
